export default __webpack_public_path__ + "static/media/digitalmarketing.91e26ef6.svg";